<template>
  <div class="mx-auto mt-10 mb-10 max-w-7xl px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <div class="grid grid-cols-1 gap-2">
        <h1
          class="text-xl font-extrabold tracking-tight text-gray-900 sm:text-2xl md:text-3xl"
        >
          <span class="text-blue-ribbon-500"> How does it work? </span>
        </h1>
        <div class="text-medium mt-3 font-semibold text-gray-900">
          Under the hood, we have developed an algorithm that combines vast
          amounts of data to provide an accurate and reliable automated quote
          every time.
        </div>
        <div class="mt-3 text-gray-500">
          <p class="">
            Once you input your car registration, our pricing engine queries all
            kinds of data, such as make and model, manufacturer service
            schedules, part numbers, oil grades, part prices and labour times.
            This data is then combined with each garages' own parameters to get
            you instant quotes in real time.
          </p>
          <p class="mt-4">
            You can be sure that each quote is really comparable and as accurate
            as it gets. A service booking made through GaragesNear.me includes
            all the tasks your car really needs, with correct parts and oil
            details. You don't have to worry about picking the right service any
            more.
          </p>
        </div>
      </div>
      <img
        src="@/assets/how-it-works.webp"
        alt="A mechanic changing a car battery."
      />
    </div>
    <div class="mt-10 flex justify-center">
      <Registration :animated="true" />
    </div>
  </div>
  <Promises />
</template>

<script setup lang="ts">
import { useHead } from '@vueuse/head'

import Registration from '@/components/Registration.vue'
import Promises from '@/components/Promises.vue'

useHead({
  title: 'How it works - GaragesNear.me',
  meta: [
    {
      name: 'og:title',
      content: 'How it works - GaragesNear.me'
    },
    {
      name: 'og:image',
      content: '/open-graph/hero.webp'
    },
    {
      name: 'og:image:alt',
      content: 'GaragesNear.me banner'
    },
    {
      name: 'og:image:width',
      content: 1280
    },
    {
      name: 'og:image:height',
      content: 576
    }
  ]
})
</script>
